import type { NavView } from "../hooks/useHashRouter";

/** Chat / Ideas / To-dos tab switcher for the selected session. To-dos is a tab only where the rail is hidden. */
export function ChatTabs({
  view,
  setView,
  setOpenIdea,
  ideaCount,
  activeTodos,
  ideas = true,
}: {
  view: NavView;
  setView: (v: NavView) => void;
  setOpenIdea: (id: string | null) => void;
  ideaCount: number;
  activeTodos: number;
  ideas?: boolean;
}) {
  return (
    // Without the Ideas tab, Chat would stand alone wherever the To-dos tab is hidden.
    <div className={ideas ? "chat-tabs" : "chat-tabs narrow-only"}>
      <button
        className={view === "chat" ? "tab active" : "tab"}
        onClick={() => {
          setView("chat");
          setOpenIdea(null);
        }}
      >
        Chat
      </button>
      {ideas && (
        <button className={view === "ideas" ? "tab active" : "tab"} onClick={() => setView("ideas")}>
          Ideas{ideaCount ? ` (${ideaCount})` : ""}
        </button>
      )}
      <button
        className={view === "todos" ? "tab narrow-only active" : "tab narrow-only"}
        onClick={() => {
          setView("todos");
          setOpenIdea(null);
        }}
      >
        To-dos{activeTodos ? ` (${activeTodos})` : ""}
      </button>
    </div>
  );
}
